import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CloseConfirmComponent } from 'src/app/admin/close-confirm/close-confirm.component';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { TimeChallengeComponent } from '../time-challenge.component';

@Component({
  selector: 'vex-edit-sub-time-challenge',
  templateUrl: './edit-sub-time-challenge.component.html',
  styleUrls: ['./edit-sub-time-challenge.component.scss']
})
export class EditSubTimeChallengeComponent implements OnInit {
  i18nTitle: any = {};
  subChallengeIndex;

  constructor(@Inject(MAT_DIALOG_DATA) public item: any['item'],private dialogRef: MatDialogRef<TimeChallengeComponent>, public translate: TranslateService, public restService: RestService, public guiService: GuiService,private dialog: MatDialog) { }

  ngOnInit(): void {
    console.debug(this.item)
    this.subChallengeIndex = this.item.index;
    this.i18nTitle['EN'] = this.item.challenge.challenges[this.subChallengeIndex].i18nTitle['EN'];
    this.i18nTitle['IT'] = this.item.challenge.challenges[this.subChallengeIndex].i18nTitle['IT'];
  }

  confirmClose(){
    this.dialog.open(CloseConfirmComponent,{
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'close-dialog-modalbox'
    }).afterClosed().subscribe((ris)=>{
      if(ris == 'true'){
        this.dialogRef.close()
      }
    })
  }

  submit(){
    setTimeout(() => this.guiService.showSpinner = true, 0);
    const param = {
      userId: this.guiService.userLogged.user.id,
      challengeId: this.item.challenge._id,
      i18nTitle: this.i18nTitle,
      index: this.item.index
    }

    this.restService.postService('node', '/update-challenge-to-time-challenge', param).subscribe((ris) => {
      this.guiService.showSpinner = false;
      this.dialogRef.close('done')
    })
  }

}
